import Handlebars from 'handlebars';
import { renderToString } from 'react-dom/server';

export const renderBuilder =
    (Component) =>
    (props = {}) =>
        Component(props);

export const registerJsxPartial = (name, Component) => {
    Handlebars.registerPartial(name, function (props) {
        return renderToString(<Component {...props} />);
    });
};
